import Info7Content from '../components/info/Info7PageContent';

const Info7Page = () => {
  return <Info7Content />;
};

export default Info7Page;